import * as ActionTypes from '../actionTypes';
import apiActionCreator from '../../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../../common/util/errorUtils';
import * as MessageActions from '../../../common/messageBox/actions/actions';

export const getWtsAgencies = (areaSelectedId) => apiActionCreator({
  'endpoint': `/wts/catalog/agency?area=${areaSelectedId}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_WTS_AGENCIES,
    ActionTypes.FETCHED_WTS_AGENCIES,
    [
      ActionTypes.FETCHED_WTS_AGENCIES_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});
export const updateWtsAgency = (areaSelectedId, data) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/wts/catalog/agency?area=${areaSelectedId}`,
      'authenticated': true,
      'types': [
        ActionTypes.UPDATING_WTS_AGENCIES,
        [
          () => {
            return {'type': ActionTypes.UPDATED_WTS_AGENCIES};
          },
          MessageActions.addMessageBoxInfo('Agencia modificada satisfactoriamente'),
        ],
        [
          ActionTypes.UPDATED_WTS_AGENCIES_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'PUT',
      'contentType': 'application/json',
      'data': data,
    })
  );
};
export const createWtsAgency = (areaSelectedId, data) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/wts/catalog/agency?area=${areaSelectedId}`,
      'authenticated': true,
      'types': [
        ActionTypes.CREATING_WTS_AGENCIES,
        [
          () => {
            dispatch(getWtsAgencies(areaSelectedId));
            return {'type': ActionTypes.CREATED_WTS_AGENCIES};
          },
          MessageActions.addMessageBoxInfo('Agencia creada satisfactoriamente'),
        ],
        [
          ActionTypes.CREATED_WTS_AGENCIES_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'POST',
      'contentType': 'application/json',
      'data': data,
    })
  );
};
export const updateWtsAgencyStatus = (areaSelectedId, data) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/wts/catalog/agency-status?area=${areaSelectedId}`,
      'authenticated': true,
      'types': [
        ActionTypes.UPDATING_WTS_AGENCIES_STATUS,
        [
          () => {
            dispatch(getWtsAgencies(areaSelectedId));
            return {'type': ActionTypes.UPDATED_WTS_AGENCIES_STATUS};
          },
          MessageActions.addMessageBoxInfo('Agencia modificada satisfactoriamente'),
        ],
        [
          ActionTypes.UPDATED_WTS_AGENCIES_STATUS_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'PUT',
      'contentType': 'application/json',
      'data': data,
    })
  );
};
export const changeWtsAgencySelected = (agencySelected) => ({
  'type': ActionTypes.CHANGE_WTS_AGENCY_SELECTED,
  'payload': agencySelected,
});
export const getWtsAgenciesDealer = (areaSelectedId, ruc) => apiActionCreator({
  'endpoint': `/wts/catalog/agency-dealer?area=${areaSelectedId}&&ruc=${ruc}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_WTS_AGENCIES_DEALER,
    ActionTypes.FETCHED_WTS_AGENCIES_DEALER,
    [
      ActionTypes.FETCHED_WTS_AGENCIES_DEALER_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});
